import React, { Fragment, useState } from 'react';
import { useAsync } from 'react-async';
import TaskTypes from '../../../api/models/tasktype';
import { getAllTaskTypes } from '../../../api/services/taskTypeService';
import Layout from '../../../components/layout';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Notification } from '../../../components/notifications';
import LayoutError from '../../../components/layoutError';
import DataTable from '../../../components/dataTable';
import { PencilIcon } from '@heroicons/react/solid';
import { sortAlphabetically } from '../../../common/utils';

type ViewState = {
  message?: string;
};

const ViewTaskTypes = () => {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Task Type Name',
        accessor: 'name',
        width: 400,
      },
      {
        id: 'taskTypeEntryTypes',
        Header: 'Type',
        accessor: (d: any) => d.taskTypeEntryTypes.length === 0 ? '-' : d.taskTypeEntryTypes.sort((a: any, b: any) => (a.entryType.name.toLowerCase() > b.entryType.name.toLowerCase()) ? 1 : -1).map((d: any) => d.entryType.name).join(', '),
        width: 300,
        className: "hidden md:table-cell"
      },
      {
        id: 'areNotesRequired',
        Header: 'Notes Required',
        accessor: (d: any) => (d.areNotesRequired ? 'Yes' : 'No'),
        wdith: 105,
        className: "hidden md:table-cell"
      },
      {
        id: 'taskTypeDisciplines',
        Header: 'Disciplines',
        accessor: (d: any) => d.taskTypeDisciplines.length === 0 ? 'Global' : d.taskTypeDisciplines.sort((a: any, b: any) => (a.discipline.name.toLowerCase() > b.discipline.name.toLowerCase()) ? 1 : -1).map((d: any) => d.discipline.name).join(', '),
        width: 400,
        className: "hidden md:table-cell"
      },
      {
        id: 'taskTypeStudentStatuses',
        Header: 'Student Status',
        accessor: (d: any) => d.taskTypeStudentStatuses.length === 0 ? '-' : d.taskTypeStudentStatuses.sort((a: any, b: any) => (a.studentStatus.name.toLowerCase() > b.studentStatus.name.toLowerCase()) ? 1 : -1).map((d: any) => d.studentStatus.name).join(', '),
        width: 400,
        className: "hidden md:table-cell"
      },
      {
        id: 'isVisible',
        Header: 'Active',
        accessor: (d: any) => (d.isVisible ? 'Yes' : 'No'),
        wdith: 84,
        className: "hidden sm:table-cell"
      },
      {
        accessor: 'taskTypeId',
        disableSortBy: true,
        Cell: () => {
          return (
            <div className='clearfix'>
              <span className='float-right'>
                <PencilIcon className="w-5 h-5 cursor-pointer" aria-hidden="true" />
              </span>
            </div>
          );
        },
        wdith: 50,
        className: "hidden sm:table-cell"
      },
    ],
    []
  );

  const history = useHistory();
  const { state } = useLocation<ViewState>();
  const [taskTypes, setTaskTypes] = useState<TaskTypes[]>([]);

  const { error, isPending } = useAsync({
    promiseFn: getAllTaskTypes,
    onResolve: (r) => setTaskTypes(sortAlphabetically(r.data.taskTypes ?? [], 'name'))
  });

  if (error) return <LayoutError />;

  return (
    <Layout isLoading={isPending}>
      <Fragment>
        {state?.message && <Notification message={state?.message} />}
        <div className='mb-4 text-right'>
          <Link className='btn' to='/admin/task-types/new'>
            Add Task Type
          </Link>
        </div>

        <DataTable
          columns={columns}
          data={taskTypes}
          showPagination={true}
          getRowProps={(row: any) => ({
            onClick: () => history.push(`/admin/task-types/${row.values.taskTypeId}`),
            className: "cursor-pointer hover:bg-gray-100",
          })}
        />
      </Fragment>
    </Layout>
  );
};

export default ViewTaskTypes;
